import React from 'react';

import { useFeatureGate } from '../../../../hooks/useFeatureGate';
import { visibleWebsiteCards, type WebsiteCardDef } from '../../cards';
import { Grid } from './WebsiteHubGrid.styles';

export type WebsiteHubGridProps = {
  /** Renders one card; `index` is its place among the cards shown (its entrance's stagger step). */
  renderCard: (card: WebsiteCardDef, index: number) => React.ReactNode;
};

/**
 * The hub's card grid: one card per Website area, in the areas' fixed order, each shown under exactly the flag that
 * shows its area. Subscribed to the feature gate, so a reveal flip adds or drops a card live.
 */
export const WebsiteHubGrid = ({ renderCard }: WebsiteHubGridProps): React.ReactElement => {
  const { isEnabled } = useFeatureGate();
  return (
    <Grid>
      {visibleWebsiteCards(isEnabled).map((card, index) => (
        <React.Fragment key={card.id}>{renderCard(card, index)}</React.Fragment>
      ))}
    </Grid>
  );
};

export default WebsiteHubGrid;
